import script from "./VRMask.vue?vue&type=script&setup=true&lang=js"
export * from "./VRMask.vue?vue&type=script&setup=true&lang=js"

import "./VRMask.vue?vue&type=style&index=0&id=f309d0d4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f309d0d4"]])

export default __exports__